import { useIntl } from 'react-intl';
import { useRouteMatch } from 'react-router-dom';
import { Form, Modal, notification } from 'antd';

import { useDefaultFormErrorNotification } from '@/hooks';

import { useCreateWorkOrderItemTag } from '@/core/domain/workorder/WorkOrderItemTags/WorkOrderItemTags.hooks';

import { ModalProps } from '@/types/ModalProps';

import CompanyWorkorderItemTagForm, {
  CompanyWorkorderItemTagFormData,
} from '../CompanyWorkorderItemTagForm';

interface Props extends ModalProps {
  companyId?: number;
}

function CreateCompanyWorkorderItemTagModal({
  visible,
  handleVisible,
  ...props
}: Props) {
  const intl = useIntl();
  const { companyId } = useRouteMatch<{ companyId: string }>().params;
  const { sendFormErrorNotification } = useDefaultFormErrorNotification();
  const [form] = Form.useForm<CompanyWorkorderItemTagFormData>();

  const mutation = useCreateWorkOrderItemTag();

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      await mutation.mutateAsync({
        ...values,
        companyId: props.companyId || +companyId,
      });

      notification.success({
        message: intl.formatMessage({
          id: 'companies.settings.itemTags.create.notification.success',
        }),
        description: intl.formatMessage({
          id: 'companies.settings.itemTags.create.notification.success.description',
        }),
      });

      handleVisible();
    } catch (err) {
      sendFormErrorNotification(err);
    }
  };

  return (
    <Modal
      open={visible}
      onCancel={handleVisible}
      title={intl.formatMessage({ id: 'companies.settings.itemTags.create' })}
      onOk={handleOk}
      confirmLoading={mutation.isLoading}
      destroyOnClose
    >
      <CompanyWorkorderItemTagForm form={form} />
    </Modal>
  );
}

export default CreateCompanyWorkorderItemTagModal;
